<template>
  <div class="container-fluid item-list image-bdcolor">
    <div class="row">
      <div class="col-1">
        <a
          v-if="
            ((currentItem !== 'set' && currentItem !== 'overview') ||
              (currentItem === 'all' && items.length > 0) ||
              (currentItem === 'overview' && isSetImageAvailable)) &&
            ((currentItem !== 0 && items.length === 1) || items.length > 1)
          "
          @click="lastItem()"
          class="last-item-arrow"
        >
          <svg width="100%" height="100%" viewBox="0 0 400 100">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M145.188,238.575l215.5-215.5c5.3-5.3,
                 5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225
                 c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"
            />
          </svg>
        </a>
      </div>
      <div ref="navigationSlider" class="col-10 no-scrollbar">
        <ul>
          <li
            id="list-item-set"
            v-if="isSetImageAvailable"
            :class="currentItem === 'set' ? 'on' : ''"
            @click="switchCurrentItem('set')"
          >
            <template>Set</template>
          </li>
          <li
            id="list-item-overview"
            v-if="isOverviewVisible"
            :class="
              currentItem === 'overview' ||
              (currentItem === 'set' && !this.isSetImageAvailable)
                ? 'on'
                : ''
            "
            @click="switchCurrentItem('overview')"
          >
            <template>
              {{ $t("Set.List.all") }}
            </template>
          </li>
          <li
            :id="'list-item-' + index"
            v-for="(item, index) in items"
            v-bind:key="index"
            v-bind:class="currentItem === index ? 'on' : ''"
            @click="switchCurrentItem(index)"
          >
            <template v-if="item.name !== ''">
              {{ item.name }}
            </template>
            <template v-else>
              {{ $t("Set.List.items") }} {{ index + 1 }}
            </template>
          </li>
          <li
            id="list-item-all"
            v-if="items.length < 4"
            :class="(currentItem === 'all' ? 'on' : '') + ' plus'"
            @click="switchCurrentItem('all')"
          >
            +
          </li>
        </ul>
      </div>
      <div class="col-1">
        <a
          v-if="
            (currentItem !== 'all' && items.length < 4) ||
            (items.length === 4 && currentItem !== 3)
          "
          @click="nextItem()"
          class="next-item-arrow"
        >
          <svg width="100%" height="100%" viewBox="0 0 400 100">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,
                 19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,
                 4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,
                 360.731,229.075z"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SetData from "@/vuex/SetData";
import Config from "@/vuex/Config";
import MediaQuery from "@/assets/Helper/MediaQuery";
import Status from "@/vuex/Status";
import Slider from "@/assets/Helper/Slider";

export default {
  name: "SetList",
  data() {
    return {
      config: this.$parent.config,
    };
  },
  mounted() {
    if (
      !MediaQuery.isDesktop() &&
      Config.getters.getConfig.visualMode === "show"
    ) {
      if (Status.getters.isInit === true) {
        //Status.dispatch("setIsInit", false);
      }
    }

    const slider = this.$refs.navigationSlider;
    Slider.setSlider(slider);
  },
  props: ["currentItem", "items"],
  methods: {
    isCurrentItemDiamond: function (newCurrentItem) {
      if (typeof this.$parent["isCurrentItemDiamond"] === "function") {
        return this.$parent["isCurrentItemDiamond"](newCurrentItem);
      }
      return false;
    },
    switchCurrentItem: function (newCurrentItem) {
      if (
        (newCurrentItem === "all" ||
          this.$parent.$parent["isInMenuList"](newCurrentItem) === false ||
          this.isCurrentItemDiamond(newCurrentItem)) &&
        this.config.visualMode !== "images"
      ) {
        Config.dispatch("setVisualMode", "show").then(() =>
          this.$root.$emit("hideLoader3D")
        );
        this.$root.$emit("setOverview");
      }

      if (newCurrentItem === "all") {
        this.$parent["showItemDetails"] = false;
      }

      if (this.currentItem !== newCurrentItem) {
        this.$parent.$parent["setCurrentItem"](newCurrentItem);

        if (
          Config.getters.getcurrentVarType !== "" &&
          !this.isCurrentItemDiamond(newCurrentItem)
        ) {
          if (this.items[newCurrentItem]) {
            let jewelleryType = parseInt(
              this.items[newCurrentItem].description.jewelleryType
            );
            if (
              jewelleryType === 0 &&
              Config.getters.getcurrentVarType === "stones/jewellery/normal"
            ) {
              Config.dispatch("setCurrentVarType", "jewellery/stones");
            } else if (
              jewelleryType > 0 &&
              Config.getters.getcurrentVarType === "jewellery/stones"
            ) {
              Config.dispatch("setCurrentVarType", "stones/jewellery/normal");
            }
          }
          this.$root.$emit("configure");
        }
      }
    },
    lastItem: function () {
      let lastItem;
      if (this.currentItem === "all") {
        lastItem = this.items.length - 1;
      } else if (this.currentItem === "overview" && this.isValidSetId()) {
        lastItem = "set";
      } else if (this.currentItem === 0) {
        lastItem = "overview";
      } else {
        lastItem = this.currentItem - 1;
      }

      this.switchCurrentItem(lastItem);
    },
    nextItem: function () {
      let nextItem;

      if (this.isValidSetId() && this.currentItem === "set") {
        nextItem = "overview";
      } else if (this.currentItem === "overview") {
        nextItem = 0;
      } else {
        nextItem = this.currentItem + 1;

        if (nextItem >= this.items.length) {
          nextItem = "all";
        }
      }

      this.switchCurrentItem(nextItem);
    },
    isValidSetId: function () {
      return SetData.getters.getShowSetImage === true;
    },
    load3dViewer: function () {
      // Check if the current item is a configurable chain
      if (
        this.items &&
        this.items[this.currentItem] &&
        this.items[this.currentItem].description &&
        this.items[this.currentItem].description.possibleVariations &&
        this.items[this.currentItem].description.possibleVariations.chainWidths
      ) {
        // Load 3D directly
        this.$root.$emit("start3dViewer");
      }
    },
  },
  computed: {
    isOverviewVisible: function () {
      return this.items.length > 1;
    },
    isDesktop() {
      return MediaQuery.isDesktop();
    },
    isSetImageAvailable() {
      return SetData.getters.getShowSetImage === true;
    },
  },
  watch: {
    items: {
      handler: function () {
        this.load3dViewer();
      },
      deep: true,
    },
    currentItem: {
      handler: function () {
        /*
        let node = document.getElementById("list-item-" + this.currentItem);
        if (node) {
          node.scrollIntoView({ block: "end", inline: "center" });
        }
        */
        this.load3dViewer();
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app .item-list {
  background-color: $darkGrey;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 1em;
  font-weight: normal;

  .col-1 {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .col-10 {
    text-align: center;
  }

  .last-item-arrow,
  .next-item-arrow {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    cursor: pointer;

    svg {
      width: 1rem;
      height: 2rem;
      margin: -1rem 0 0 0;
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: inline-block;
    width: max-content;
    text-align: center;

    li {
      margin: 0;
      padding: 1.5rem 2rem;
      display: inline-block;
      line-height: 2em;
      font-size: 1em;
      cursor: pointer;
      color: $black;
      opacity: 0.8;
      letter-spacing: 0.1em;
    }

    li.on {
      border-bottom: none;
      font-weight: bold;
      opacity: 1;
      color: $fontColor;
      border-bottom: solid 0.1rem $black;
    }

    li.plus {
      width: 4em;
    }
  }
}
</style>
